module.exports = __webpack_public_path__ + "sl.4db27f7c929009b2da07.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sl.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sl.svg
// module chunks = styles